// import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { getPageType, getProfilePublicId, getCurrentTab } from "@/libs/utils";

export const useChromeStore = defineStore("chrome", {
  state: () => ({
    tab: null as chrome.tabs.Tab | null,
  }),
  getters: {
    url: (state) => state.tab?.url || "",
    domain: (state) => {
      const url = new URL(state.tab?.url!);
      return url.hostname || new URL(url.pathname).hostname;//查看源代码时发现这里有问题，应该是 || 后
    },
    title: (state) => state.tab?.title || "",
    favIconUrl: (state) => state.tab?.favIconUrl || "",
    pageType: (state) => {
      if (state.tab) {
        return getPageType(state.tab.url);
      }
      return "";
    },
    publicId: (state) => {
      return getProfilePublicId(state.tab?.url);
    },
  },
  actions: {
    setCurrentTab(tab?: chrome.tabs.Tab) {
      if (tab !== undefined) {
        this.tab = tab;
        return Promise.resolve(tab);
      } else {
        return getCurrentTab().then((tab) => {
          this.tab = tab;
          return tab;
        });
      }
    },
  },
});
